import React from 'react';
import AnimationProductionTracker from './components/AnimationProductionTracker';
import './App.css';

function App() {
  return (
    <div className="App h-screen">
      <AnimationProductionTracker />
    </div>
  );
}

export default App;